import axios, { AxiosResponse } from 'axios'

import { HttpErrorData } from '@/data/types'

export class HttpError extends Error {
  constructor(readonly data: HttpErrorData) {
    super(data.title)
  }
}

export class HttpService {
  readonly url: string
  constructor(readonly host: string) {
    this.url = `${this.host}/api`
  }

  async get<ParamsType, ResponseType>(
    endpoint: string,
    params?: ParamsType
  ): Promise<AxiosResponse<ResponseType>> {
    const fn = async () => {
      const res = await axios.get(`${this.url}/${endpoint}`, {
        params,
      })
      return res as AxiosResponse<ResponseType>
    }
    return handleHttpError(fn)
  }
}

async function handleHttpError<ResponseType>(
  fn: () => Promise<AxiosResponse<ResponseType>>
) {
  try {
    const res = await fn()
    return res
  } catch (e) {
    if (axios.isAxiosError(e)) {
      if (!e.response) {
        throw new HttpError({
          title: 'Erro de conexão',
          detail: 'Não foi possível se conectar com o servidor.',
        })
      } else {
        throw new HttpError(e.response.data)
      }
    } else {
      throw e
    }
  }
}

export const httpService = new HttpService(process.env.VUE_APP_URL)
